import React from 'react';
import { NotificationsContainer as UiKitNotificationsContainer } from '@fountain/ui-kit/components/notifications';
import './styles.pcss';

export default function NotificationsContainer() {
  return <UiKitNotificationsContainer className="notifications-container" />;
}
